import { IClientAppSettings } from "./clientAppSettings"
const clientAppSettings: IClientAppSettings = {
    logServerRequests: false,
    logServerResponses: false,
    env: "Prod",
}

export default clientAppSettings
